<template>
    <landing-page-pro-user
            :company-logo="cardCompanyLogo"
            :display-name="cardDisplayName"
            :email="cardEmail"
            :phones="cardPhones"
            :social-links="cardSocialLinks"
            :occupation="cardOccupation"
            :loan-officer-license="cardLoanOfficerLicense"
            :has-extras="true"
            :landing-page-notice="landingPageNotice"
            :landing-page-links="landingPageLinks"
            :company-name="cardCompanyName"
            background-color="tw-bg-white"
            :primary-color="landingPage.primaryColor"
            :user="landingPage.user"
    />
</template>
<script>
import LandingPageProUser from "./LandingPageProUser/LandingPageProUser.vue";
import FileAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/FileAppResource";
import {
    DESTINED_TO as PHONE_DESTINED_TO
} from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPagePhoneAppResource";
import {
    DESTINED_TO as SOCIAL_LINK_DESTINED_TO
} from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageSocialLinkAppResource";
import LandingPageAppResource from "@milestoneslabs/milestones-core-js/src/AppResources/LandingPageAppResource";

export default {
    name: 'LandingPageRealEstateAgent',
    components: {LandingPageProUser},
    mixins: [],
    props: {
        landingPage: {
            type: LandingPageAppResource,
            required: true,
        }
    },
    data() {
        return {
        };
    },
    computed: {
        cardAvatar() {
            return this.landingPage?.avatar || new FileAppResource({});
        },
        cardCompanyLogo() {
            return this.landingPage?.user?.organizationLogo?.publicStorageUrl || '';
        },
        cardCompanyName() {
            return this.landingPage?.user?.meta?.company || '';
        },
        cardDisplayName() {
            return this.landingPage.firstName + ' ' + this.landingPage.lastName;
        },
        cardEmail() {
            return this.landingPage.email || '';
        },
        cardPhones() {
            return this.landingPage?.phones ?
                this.landingPage.phones.toArray().filter(item => {
                    return item.destinedTo === PHONE_DESTINED_TO.REAL_ESTATE_AGENT;
                }) :
                [];
        },
        cardSocialLinks() {
            return this.landingPage?.socialLinks ?
                this.landingPage.socialLinks.toArray().filter(item => {
                    return item.destinedTo === SOCIAL_LINK_DESTINED_TO.REAL_ESTATE_AGENT;
                }) :
                [];
        },
        cardOccupation() {
            return this.landingPage?.sell?.projectMembershipType ?
                {
                    name: this.landingPage.sell.projectMembershipType.name,
                    slug: this.landingPage.sell.projectMembershipType.slug,
                } :
                {
                    name: '',
                    slug: '',
                };

        },
        cardLoanOfficerLicense() {
            return this.landingPage?.user?.loanOfficerLicense || {};
        },
        landingPageNotice() {
            return this.landingPage?.notice || '';
        },
        landingPageLinks() {
            let links = [];
            if (!this.landingPage?.links?.appResources) {
                return links;
            }
            Object.values(this.landingPage.links.appResources).forEach((link) => {
                links.push({
                    title: link.title,
                    url: link.url,
                });
            });
            return links;
        },
    },
    methods: {

    }
};
</script>
